const pageObj = {
  "환자 조회": {
    title: "환자조회",
    subTitle: `검색조건에 따라 환자들을 검색하고, 검색된 환자를 선택하면 환자현황을 상세하게 볼수 있는 대시보드 화면이 나타납니다.`,
  },
  "처방전 템플릿": {
    title: "템플릿 리스트",
    subTitle: "알코올중독치료 처방전 템플릿을 등록하고 관리할 수 있습니다.",
  },
  "치료제 조회": {
    title: "치료제 리스트",
    subTitle:
      "치료제는 치료약들로 구성된 패키지 입니다. 치료제 추가화면에서 치료약들을 검색하여 치료제를 구성해주세요. 등록된 치료제들은 알코올중독치료 처방전에 할당할 수 있습니다.",
  },
  "치료제 카테고리": {
    title: "치료제 카테고리",
    subTitle: "치료제를 위한 카테고리를 추가하고 치료제에 지정해주세요",
  },
  "치료약 조회": {
    title: "치료약 리스트",
    subTitle:
      "치료약은 OX퀴즈, 주관식, 객관식, 동영상, 사운드 등 다양한 형태의 치료약 타입으로 등록할 수 있습니다. 미디어파일 용량이 클 경우 등록할때 시간이 걸릴 수 있습니다.",
  },
  "치료약 카테고리": {
    title: "치료약 카테고리",
    subTitle: "치료약를 위한 카테고리를 추가하고 치료약에 지정해주세요",
  },
  "공통코드 관리": {
    title: "공통코드 관리",
    subTitle:
      "시스템 전반적으로 사용되는 코드들을 관리할 수 있습니다. 수정, 삭제시 다른 기능에 영향이 있을수 있습니다.",
  },
  "권한 관리": {
    title: "권한 관리",
    subTitle:
      "시스템 괸리자, 의사, 간호사 등의 접근할 수 있는 권한을 설정할 수 있습니다.",
  },
  "기능 관리": {
    title: "기능 관리",
    subTitle:
      "페이지 접근 후 검색, 등록, 삭제등의 기능에 제약을 설정할 수 있습니다",
  },
  "메뉴 관리": {
    title: "메뉴 관리",
    subTitle: `메뉴를 추가하거나 수정할수 있습니다. 메뉴관리는 시스템 관리자만 접근할 수 있습니다. `,
  },
  "유저 관리": {
    title: "사용자 관리",
    subTitle:
      "시스템 관리자는 사용자를 등록하고 관리할 수 있습니다. 사용자는 환자를 등록하여 처방할 수 있습니다.",
  },
  "기관 관리": {
    title: "기관 관리",
    subTitle:
      "기관을 등록하고 관리할수 있습니다. 현재는 한림대학교 하나의 기관으로 관리됩니다.  ",
  },
  "앱 로그 조회": {
    title: "앱 로그 조회",
    subTitle:
      "알코올 중독치료, 인지장애치료 앱 사용 로그를 조회할 수 있습니다. ",
  },
  "앱 버전 관리": {
    title: "앱 버전 관리",
    subTitle: "AStop, MindStrong 앱 버전과 업데이트 팝업 정보를 관리합니다.",
  },
  FAQ: {
    title: "FAQ",
    subTitle: "자주 문의 되는 내용에 대한 답변입니다.",
  },
  "Q&A": {
    title: "Q&A",
    subTitle: "환자가 질의한 내용을 확인하고 답변할 수 있습니다.",
  },
};
export default pageObj;
